/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Bundle_Youpaymore2Inputs */

const id_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda bayar lebih:`)
};

const ms_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda bayar lebih:`)
};

const da_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du betaler mere:`)
};

const de_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie zahlen mehr:`)
};

const en_us2_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You pay more:`)
};

const es_es2_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagas más:`)
};

const es_mx2_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagas más:`)
};

const fil_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagdag na babayaran:`)
};

const fr_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous payez plus :`)
};

const it_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paghi di più:`)
};

const hu_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Többet fizetsz:`)
};

const nl_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je betaalt meer:`)
};

const no_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du betaler mer:`)
};

const pl_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płacisz więcej:`)
};

const pt_br2_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You pay more:`)
};

const pt_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paga mais:`)
};

const ro_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plătești mai mult:`)
};

const fi_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksat enemmän:`)
};

const sv_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du betalar mer:`)
};

const vi_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn trả thêm:`)
};

const tr_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazla ödeme:`)
};

const cs_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připlatíte:`)
};

const bg_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плащате повече:`)
};

const ru_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы платите больше:`)
};

const uk_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви доплачуєте:`)
};

const ar_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدفع أكثر:`)
};

const hi_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप अधिक भुगतान करते हैं:`)
};

const th_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจ่ายเพิ่ม:`)
};

const ja_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加支払額：`)
};

const zh_cn2_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You pay more:`)
};

const zh_hant1_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You pay more:`)
};

const ko_components_bundle_youpaymore2 = /** @type {(inputs: Components_Bundle_Youpaymore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You pay more:`)
};

/**
* | output |
* | --- |
* | "You pay more:" |
*
* @param {Components_Bundle_Youpaymore2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_bundle_youpaymore2 = /** @type {((inputs?: Components_Bundle_Youpaymore2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Bundle_Youpaymore2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_bundle_youpaymore2(inputs)
	if (locale === "ms") return ms_components_bundle_youpaymore2(inputs)
	if (locale === "da") return da_components_bundle_youpaymore2(inputs)
	if (locale === "de") return de_components_bundle_youpaymore2(inputs)
	if (locale === "en-US") return en_us2_components_bundle_youpaymore2(inputs)
	if (locale === "es-ES") return es_es2_components_bundle_youpaymore2(inputs)
	if (locale === "es-MX") return es_mx2_components_bundle_youpaymore2(inputs)
	if (locale === "fil") return fil_components_bundle_youpaymore2(inputs)
	if (locale === "fr") return fr_components_bundle_youpaymore2(inputs)
	if (locale === "it") return it_components_bundle_youpaymore2(inputs)
	if (locale === "hu") return hu_components_bundle_youpaymore2(inputs)
	if (locale === "nl") return nl_components_bundle_youpaymore2(inputs)
	if (locale === "no") return no_components_bundle_youpaymore2(inputs)
	if (locale === "pl") return pl_components_bundle_youpaymore2(inputs)
	if (locale === "pt-BR") return pt_br2_components_bundle_youpaymore2(inputs)
	if (locale === "pt") return pt_components_bundle_youpaymore2(inputs)
	if (locale === "ro") return ro_components_bundle_youpaymore2(inputs)
	if (locale === "fi") return fi_components_bundle_youpaymore2(inputs)
	if (locale === "sv") return sv_components_bundle_youpaymore2(inputs)
	if (locale === "vi") return vi_components_bundle_youpaymore2(inputs)
	if (locale === "tr") return tr_components_bundle_youpaymore2(inputs)
	if (locale === "cs") return cs_components_bundle_youpaymore2(inputs)
	if (locale === "bg") return bg_components_bundle_youpaymore2(inputs)
	if (locale === "ru") return ru_components_bundle_youpaymore2(inputs)
	if (locale === "uk") return uk_components_bundle_youpaymore2(inputs)
	if (locale === "ar") return ar_components_bundle_youpaymore2(inputs)
	if (locale === "hi") return hi_components_bundle_youpaymore2(inputs)
	if (locale === "th") return th_components_bundle_youpaymore2(inputs)
	if (locale === "ja") return ja_components_bundle_youpaymore2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_bundle_youpaymore2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_bundle_youpaymore2(inputs)
	return ko_components_bundle_youpaymore2(inputs)
});
export { components_bundle_youpaymore2 as "components.bundle.youPayMore" }